import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/home';
import 'bootstrap/dist/css/bootstrap.css';
import "./style/DJ15_root.css";
import JoinGroupSite from './pages/joinGroup';
import { RecoilRoot } from 'recoil';

function App() {
    return (
        <RecoilRoot>
            <BrowserRouter basename='/token/dj15'>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/join" element={<JoinGroupSite />} />
                </Routes>
            </BrowserRouter>
      </RecoilRoot>
    );
  }
  
// Render your React component instead
const root = createRoot(document.getElementById('app'));
root.render(<App />);
